export interface PerformanceSummary {
  label: 'Profit' | 'Loss';
  amount: number;
  percentage: number;
  isProfit: boolean;
}

export const getPerformanceSummary = (
  performance: any,
): PerformanceSummary | null => {
  if (!performance) return null;

  if (performance.profits_in_value !== undefined) {
    return {
      label: 'Profit',
      amount: performance.profits_in_value,
      percentage: performance.profits_in_percentage,
      isProfit: true,
    };
  }

  if (performance.loss_in_value !== undefined) {
    return {
      label: 'Loss',
      amount: performance.loss_in_value,
      percentage: performance.loss_in_percentage,
      isProfit: false,
    };
  }

  return null;
};
